import { InjectionToken } from '@angular/core';
import { IrisPage } from '@iris/common/models/page';
import { Observable, Subject } from 'rxjs';

export interface IrisSkSelectFieldSearchEngine<TItem, TValue> {
  result$: Observable<IrisPage<TItem>>;

  loading$?: Observable<boolean>;
  typeahead?: Subject<string>;
  getMissingItemLabelFn?: (value: TValue) => string | Observable<string>;

  resultOnInit?: boolean;
  reloadOnOpen?: boolean;
  needScrollToTop?: (prev: TItem[], curr: TItem[]) => boolean;
  dispose?: () => void;
}

export const SEARCH_ENGINE = new InjectionToken<IrisSkSelectFieldSearchEngine<unknown, unknown>>('Sk-select-field search engine');
